<template>
  <div v-if="!isNoSearch" class="api-domain">
    <input type="text" :name="apiSearchInputName" class="api-domain-search-input" :placeholder="definition.label" v-model="apiSearchValue" @blur="apiSearchAction()">
    <button class="api-domain-search-button" v-on:click="apiSearchAction()">
    <transition name="fade" mode="out-in">
      <i v-if="!apiSearch && !apiResult" class="fa fa-search"></i>
      <template v-else-if="!apiSearch && apiResult">
        <span v-if="apiResultOk" class="api-results-number">{{ apiResultsNumber }}</span>
        <i v-else class="sherpa-icon icon-ico_error"></i>
      </template>
      <spinner-loading v-else :line-size='2' :size="16" line-fg-color='#777' />
    </transition>
    </button>
  </div>
  <div v-else-if="apiSearch || apiResult" class="no-search-loading">
    <spinner-loading :line-size='2' :size="16" line-fg-color='#777' />
  </div>
</template>

<script>
import * as api from '../utils/definitionApi'
import SpinnerLoading from 'vue-simple-spinner'
import language from '../language'
import transport from 'vue-definition-utils/src/utils/transport'

export default {
  name: 'definition-choice-api',
  props: [
    'definition',
    'type',
    'authorization',
    'definitionContentId',
    'language',
    'isNoSearch',
    'content'
  ],
  components: {
    SpinnerLoading
  },
  data () {
    return {
      apiSearch: false,
      apiResult: false,
      apiResultOk: false,
      apiSearchValue: '',
      apiResultsNumber: 0
    }
  },
  mounted () {
    setTimeout(() => {
      this.apiSearchAction()
    }, 500)
  },
  methods: {
    getLang (key) {
      return language(this.language, key)
    },
    apiSearchAction () {
      if (!this.apiSearch && (this.apiSearchValue !== '' || this.isNoSearch)) {
        this.apiSearch = true
        api.call({domainEndpoint: this.type.domainEndpoint, url: this.definition.validation.format.regExp, token: this.type.token, version: this.type.version, method: 'POST', lang: this.getLang(), authorization: this.authorization, data: { id: this.apiSearchValue, code: this.definitionContentId }})
          .then(resp => {
            if (resp && resp.length > 0) {
              if (this.definition) {
                if (this.definition.validation && !this.definition.validation.domain) {
                  this.definition.validation.domain = []
                }
                this.addApiValue(resp)
                this.apiResultsNumber = resp.length
                this.apiResultOk = true
              } else {
                this.apiResultsNumber = 0
                this.apiResultOk = false
              }
            } else {
              this.apiResultsNumber = 0
              this.apiResultOk = false
            }
            this.apiSearch = false
            this.apiResult = true
            var vm = this
            setTimeout(() => {
              vm.apiResult = false
              vm.apiSearchValue = ''
            }, 2400)
          })
          .catch(err => {
            console.log(err)
            this.apiSearch = false
            this.apiResult = false
            this.apiResultOk = false
            this.apiResultsNumber = 0
            this.apiSearchValue = ''
          })
      }
    },
    addApiValue (domainValue) {
      let push = true
      if (domainValue.length > 1) {
        push = false
      }
      domainValue.forEach(el => {
        if (this.valueNotAdded(el.key)) {
          this.definition.validation.domain.push(el)
          let reqDef = transport.methods.getRequestDefinitionById(this.definition.id, this.content.requestDefinition)
          if (reqDef) {
            if (!reqDef.validation.domain) {
              reqDef.validation.domain = []
            }
            reqDef.validation.domain.push(el)
          }
        }
        if (push) {
          this.$emit('apiElementAdded', el)
        }
      })
    },
    valueNotAdded (key) {
      var result = true
      this.definition.validation.domain.every(el => {
        result = el.key !== key
        return result
      })
      return result
    }
  },
  computed: {
    apiSearchInputName () {
      return 'searcher-api-' + this.definition.id
    }
  }
}
</script>

<style lang="scss" scoped>
.no-search-loading {
  margin-top: 7px;
  position: absolute;
  bottom: 19px;
  right: 31px;
  z-index: 1;
}
.api-domain {
  .api-domain-search-input {
    width: calc(100% - 30px);
    border-top: 1px solid #ccc !important;
    border-bottom: 1px solid #ccc !important;
    border-left: 1px solid #ccc !important;
    border-right: 0 !important;
    font-family: "Source Sans Pro", sans-serif;
    padding: 3px 10px 2px 12px;
    background-color: #f4f4f4;
    font-size: 15px;
    color: #666;
    float: left;
    height: 33px;

    &::placeholder {
      color: #888;
      font-size: 14px;
      font-style: italic;
    }

    &:focus {
      border: 0;
      outline: 0;
    }
  }
  .api-domain-search-button {
    color:#fff;
    width: 30px;
    border-top: 1px solid #ccc;
    border-bottom: 0;
    border-left: 1px solid #ccc;
    border-right: 1px solid #ccc;
    height: 33px;
    vertical-align: top;
    background-color: #d42e12;
    cursor: pointer;
    padding: 0;

    .sherpa-icon {
      font-size: 17px;
      line-height: 29px;

      &.icon-ico_error {
        color:#000;
      }
    }

    .api-results-number {
      color: #fff;
      font-weight: 600;
      font-family: "Source Sans Pro", sans-serif;
      font-size: 15px;
      font-style: italic;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/content/definitionLoader/item/choiceApi.vue